<template>
  <div>
    <v-container class="pa-0 wizard-uvod">
      <v-form @input="updateFormValid" ref="form" autocomplete="off">
        <debug-control
          @click="log"
          v-if="debug"
          :value="[
            'validationObjectResult',
            'formValid',
            'somethingGetDirty',
            'somethingIsLoading',
            'currentControl',
            'zastupca',
            'pripad',
          ]"
          :parent="this"
        />
        <div class="wizard-content">
          <uvod-banner :isMobile="isMobile"></uvod-banner>
          <!-- this.validationObjectResult && this.formValid && this.formControlsLoaded -->
          <v-card class="card-forma-podnikania card">
            <template v-if="jePrihlaseny">
              <h2 class="mb-2">Výber profilu</h2>
              <span class="gs100 f16"
                >Ponuku vytvárate k profilu
                <span class="white100 f16">{{ currentProfileName }}</span>
              </span>
              <br />
              <span class="gs100 f16"
                >Ak si prajete vybrať iný profil, prejdite do menu vpravo hore.</span
              >
              <br />
              <v-btn class="btn-secondary mt-6" @click="getCreateProfileLink()">
                Vytvoriť nový profil
              </v-btn>
            </template>
            <template v-else>
              <h2 class="mb-6">Nájomca</h2>
            </template>
            <uvod-forma
              ref="formaPodn"
              v-show="!jePrihlaseny"
              :parentReloaded="reloaded"
              :disabled="vytvaranieZakaznikaPrebieha"
              v-model="formaPodn"
            ></uvod-forma>
          </v-card>
        </div>
      </v-form>
    </v-container>
  </div>
</template>
<script>
import CheckBox from '../basic/CheckBox.vue';
import ComboBox from '../basic/ComboBox.vue';
import DynamicCombo from '../basic/DynamicCombo.vue';
import DynamicSearchCombo from '../basic/DynamicSearchCombo.vue';
import ButtonGroup from '../basic/ButtonGroup.vue';
import TextBox from '../basic/TextBox.vue';
import DatePicker from '../basic/DatePicker.vue';
import UploadArea from '../basic/UploadArea.vue';
import Ico from '../basic/Ico.vue';
import protectedAxios from '../../auth/axios';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { wizardMixin } from '../../mixins/wizardMixin.js';
import MessageBox from '../basic/MessageBox.vue';
import UvodForma from '../uvod/UvodForma.vue';
import UvodBanner from '../uvod/UvodBanner.vue';
import { eventBus } from '../../main.js';

export default {
  mixins: [wizardMixin],
  components: {
    TextBox,
    DynamicCombo,
    DynamicSearchCombo,
    CheckBox,
    UploadArea,
    ButtonGroup,
    DatePicker,
    Ico,
    MessageBox,
    ComboBox,
    UvodForma,
    UvodBanner,
  },
  data() {
    return {
      formaPodn: null,
      defaultMessage: {
        text: '',
        isError: false,
      },
    };
  },
  computed: {
    ...mapState(['wizardFormControls', 'pripad']),
    ...mapGetters('auth', ['currentProfileName']),
    ...mapGetters([
      'pripadFromPostParams',
      'vytvaranieZakaznikaPrebieha',
      'pravoNaAdresnuPonuku',
      'jePrihlaseny',
      'isMobile'
    ]),
  },
  methods: {
    ...mapMutations(['setPripadFromPostParams']),

    //beforeStep vola PripadyWizard.vue po validacii formulara. Musi vratit promise !!!
    async beforeStep() {
      return Promise.resolve(true);
    },
    reload() {
      this.$refs.formaPodn.loadData();
    },

    async getCreateProfileLink() {
      await protectedAxios.get('/login/create-profile-link').then(res => {
        if (res.data.redirectUrl) {
          let query = '?ref=eklient';
          let obcNum = localStorage.getItem('curr_new_obc_num');
          let step = localStorage.getItem('curr_new_obc_step');

          if (obcNum) {
            query += '&obcNum=' + obcNum;
          }
          if (step) {
            query += '&step=' + step;
          }

          window.onbeforeunload = null;
          window.location.href = res.data.redirectUrl + query;
        }
      });
    },
  },

  async mounted() {
    this.$on('formControlsLoaded', () => {
      if (this.pripadFromPostParams) {
        this.setPripadFromPostParams(null);
      }
    });
  },
};
</script>
